import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['12px', '12px'],
  middle: ['24px', '24px'],
  large: ['48px', '48px'],
};

const TrelloIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={sizes[props.size][0]}
    height={sizes[props.size][1]}
    style={{
      ...(props.shouldPadding
        ? {
            padding: '4px',
          }
        : {}),
    }}
  >
    <path
      fill="#1E88E5"
      d="M6,10c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v28c0,2.2-1.8,4-4,4H10c-2.2,0-4-1.8-4-4V10z"
    />
    <path
      fill="#FFF"
      d="M10,12.2c0-1.2,1-2.2,2.2-2.2h7.6c1.2,0,2.2,1,2.2,2.2v21.6c0,1.2-1,2.2-2.2,2.2h-7.6C11,36,10,35,10,33.8V12.2z M26,22.8c0,1.2,1,2.2,2.2,2.2h7.6c1.2,0,2.2-1,2.2-2.2V12.2c0-1.2-1-2.2-2.2-2.2h-7.6C27,10,26,11,26,12.2V22.8z"
    />
  </svg>
);
TrelloIcon.propTypes = {
  size: PropTypes.string,
  shouldPadding: PropTypes.bool,
};
TrelloIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
};

export default TrelloIcon;
